var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListDarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4219 0.5H2.07812C1.48269 0.5 1 1.00368 1 1.625V11.375C1 11.9963 1.48269 12.5 2.07812 12.5H11.4219C12.0173 12.5 12.5 11.9963 12.5 11.375V1.625C12.5 1.00368 12.0173 0.5 11.4219 0.5Z",
    stroke: "#525B7A",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.16666H11H2.5H1V4.16666H2.5H11H12.5V3.16666ZM12.5 6.16667H11H2.5H1V7.16667H2.5H11H12.5V6.16667ZM11 9.16667H12.5V10.1667H11H2.5H1V9.16667H2.5H11Z",
    fill: "#525B7A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDarkIcon);
export default __webpack_public_path__ + "static/media/listDarkIcon.10f6bcbf26fc4c7fee970eff7903c752.svg";
export { ForwardRef as ReactComponent };